export const EManualExternalOrderDeliveryType = {
  None: 0,
  Pickup: 1,
  Delivery: 2,
  OwnDelivery: 3,
  PlatformDelivery: 4,
  Other: 5,
} as const

export type EManualExternalOrderDeliveryType =
  (typeof EManualExternalOrderDeliveryType)[keyof typeof EManualExternalOrderDeliveryType]
